import Page from '../../page';

export default class ReferencesEntry extends Page {
    constructor(...args) {
        super(...args);

        this._retrieveDOM();
        this._initTls();
        this._initHeaderCarousel();
    }

    _retrieveDOM() {
        this.dom.views = {};
        this.dom.views.slideImages = this.dom.component.querySelectorAll('.js-reference-slide-image');
    }

    _initHeaderCarousel() {
        if (this.dom.views.slideImages.length <= 0) return;

        this.headerCarousel = {};

        // set slider index
        this.headerCarousel.index = 0;

        // get active image
        this.headerCarousel.activeImage = Array.prototype.filter.call(this.dom.views.slideImages, (element, index, aElements) => {
            return element.classList.contains('active');
        })[0];

        // auto switch image
        setInterval(() => {
            if(this.headerCarousel.index < this.dom.views.slideImages.length - 1 ) {
                // increment index if not last
                this.headerCarousel.index += 1;
            } else {
                // reset to 0 if last
                this.headerCarousel.index = 0;
            }

            // hide prev image
            this.headerCarousel.activeImage.classList.remove('active');

            // show next image
            const nextImage = this.dom.views.slideImages.item(this.headerCarousel.index);
            nextImage.classList.add('active');
            this.headerCarousel.activeImage = nextImage;

        }, 4000)
    }


    /**
     * init() {}
     * bind() {}
     * unbind() {}
     * resize(width, height) {}
     * _destroy() {}
     */
}



// WEBPACK FOOTER //
// ./src/js/pages/references/entry/references-entry.js